<template>
    <DsDialog
        v-model:open="isOpen"
        :primaryLoading
        primaryLabel="Create file"
        secondaryLabel="Back to editing"
        title="Create this file?"
        @clickPrimary="emit('confirm')"
        @clickSecondary="isOpen = false"
    >
        <div class="grid gap-4">
            <p class="text-content-lg text-content-primary">
                Review the details below before continuing. Clients assigned tasks will receive email and/or text notifications.
            </p>

            <DsCard>
                <p class="mb-3 text-content-lg font-semibold text-content-primary">File details</p>
                <dl class="grid gap-2">
                    <div
                        v-for="detail in fileDetailRows"
                        :key="detail.label"
                        class="flex items-start justify-between gap-4"
                    >
                        <dt class="whitespace-nowrap text-content-md font-normal text-content-primary">{{ detail.label }}</dt>
                        <dd class="text-right text-content-md font-medium text-content-primary">
                            {{ detail.value || EMPTY_CELL_CONTENT }}
                        </dd>
                    </div>
                </dl>
            </DsCard>

            <DsCard>
                <p class="mb-3 text-content-lg font-semibold text-content-primary">Client information</p>
                <div class="grid gap-4">
                    <template
                        v-for="(client, index) in summary.clients"
                        :key="client.id"
                    >
                        <hr
                            v-if="index > 0"
                            class="border-ds-gray-200"
                        />
                        <AddFileConfirmationClientCard :client="client" />
                    </template>
                </div>
            </DsCard>
        </div>
    </DsDialog>
</template>

<script setup lang="ts">
import { useAddFileStore } from '@/company-portal/add-file/add-file.store';
import { EMPTY_CELL_CONTENT } from '@/components/Components/static-content';
import DsCard from '@/components/design-system/DsCard.vue';
import DsDialog from '@/components/design-system/DsDialog.vue';
import AddFileConfirmationClientCard from '@/components/Views/Company/AddFile/ConfirmationDialog/AddFileConfirmationClientCard.vue';
import { computed } from 'vue';

defineProps<{ primaryLoading?: boolean }>();
const emit = defineEmits<{ confirm: [] }>();

const isOpen = defineModel<boolean>('open');

const addFileStore = useAddFileStore();
const summary = computed(() => addFileStore.confirmationSummary);

const fileDetailRows = computed(() => {
    const { fileDetails } = summary.value;
    return [
        { label: 'File reference #', value: fileDetails.referenceNumber },
        { label: 'Property address', value: fileDetails.propertyAddress },
        { label: 'Company', value: fileDetails.company },
        { label: 'Branch', value: fileDetails.branch },
        { label: 'Closing date', value: fileDetails.closingDate },
        { label: 'Balance due', value: fileDetails.balanceDue },
    ];
});
</script>
